import React from "react";
import SimpleMDEReact from "react-simplemde-editor";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button } from "react-bootstrap";

interface Props {
    showingTagName: any, 
    tagData:any,
    handleTagDataCancel:any
}

const TagData = ({ showingTagName,tagData,handleTagDataCancel }: Props)=>{
    const options = {
        autofocus: true,
        autosave: {
            enabled: true,
            uniqueId: "1",
            delay:1000,
        },
    };
    return (
      <>
        <div>
            <p className="mb-4" style={{ color: "#4b4b5a", textAlign: "left", fontWeight: "bold", }} >TAG: {showingTagName}</p> 
            <div > 
                <SimpleMDEReact options={options} className="overflowAuto" value={tagData} /> 
            </div>
            <div style={{ marginTop: "15px" }}>
            <CopyToClipboard text={tagData}>
                <Button style={{marginLeft:"0"}} variant="primary">Copy Tag to Clipboard</Button>
            </CopyToClipboard>
            <Button variant="secondary" onClick={handleTagDataCancel}>Cancel</Button>
            </div>
        </div>
      </>
    );
}

export default TagData;